module.exports = __webpack_public_path__ + "img/edc-blibli.ad79f55e.png";